exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-6ac1c7f6] {\r\n    padding: auto;\n}\n.filter-item[data-v-6ac1c7f6] {\r\n    margin-right: 10px;\r\n    margin-bottom: 10px;\n}\n.box-left[data-v-6ac1c7f6] {\r\n    width: 15vw;\r\n    margin: 10px;\n}\n.box-right[data-v-6ac1c7f6] {\r\n    width: 70vw;\r\n    margin: 10px;\n}\n.box[data-v-6ac1c7f6] {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\n}\r\n", ""]);

// exports
